import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics 4 Component
const GoogleAnalytics = ({ measurementId }) => {
  const location = useLocation();

  // Load GA4 script on mount
  useEffect(() => {
    if (!measurementId) return;

    // Check if script already exists
    if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) {
      return;
    }

    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    
    gtag('js', new Date());
    gtag('config', measurementId, {
      send_page_view: false // We'll send page views manually for SPA
    });

    console.log('Google Analytics initialized:', measurementId);
  }, [measurementId]);

  // Track page views on route change
  useEffect(() => {
    if (!measurementId || !window.gtag) return;

    // Send page view
    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: location.pathname + location.search
    });
  }, [location, measurementId]);

  return null;
};

export default GoogleAnalytics;
